import { PRODUCT_TOUR_VERSION, type AccountProfile } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";

export const markProductTourComplete = (): Promise<AccountProfile> =>
  apiClient<AccountProfile>("/auth/me/product-tour/complete", {
    method: "POST",
    body: JSON.stringify({ version: PRODUCT_TOUR_VERSION }),
  });
